import { useEffect, useState } from 'react';
import * as FileSaver from 'file-saver';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import ButtonComponent from './ButtonComponent';


const formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
};
 
const ExportPDFButton = ({ tag, dataList, tableHeader }) => {
    const [currentDate, setCurrentDate] = useState('');
    const fileExtension = '.pdf';

    
    useEffect(() => {
        setCurrentDate(new Date().toLocaleDateString().replace(/\//g, '-'));
    }, []);
 
    const onExport = () => {
        // Create a new PDF document
        const doc = new jsPDF();
        // Add title
        doc.setFontSize(17);
        doc.setTextColor(40);
        // doc.setFont('helvetica', 'bold');
        doc.setFont('helvetica', 'bold');
        // Modify the tag to remove hyphens and display as title
        const formattedTag = tag.toUpperCase().replace(/-/g, ' ');
        doc.text(formattedTag, 14, 15);

        // Add timestamp to top right corner
        // const timestamp = new Date().toLocaleString(undefined, { timeZoneName: 'short' });
        const now = new Date();
        const timestamp = now.toLocaleString('en-US', { timeZone: 'America/New_York' }) + ' (EST)';
        doc.setFontSize(8);
        doc.setFont('helvetica', 'normal');
        const pageWidth = doc.internal.pageSize.getWidth();
        doc.text(timestamp, pageWidth - 10, 10, { align: 'right' })
        
        // Prepare data for the table
        let tableData = [];
        let headers = [];
        let filteredTableHeader = [];
        if (tableHeader) {
            // Filter out headers with columnname 'blank'
            filteredTableHeader = tableHeader.filter(header => header.columnname !== 'blank');

            // Extract headers from filteredTableHeader
            headers = filteredTableHeader.map(header => header.columntag);
            console.log(headers)
            // Process data rows
            tableData = dataList.map(item => {
                // For each row, extract values based on column names
                return tableHeader.map(header => {
                    // Get the value for this cell
                    let value = item[header.columnname];
                    console.log(header.columnname)
                    console.log(value)
                    if (header.columnname === 'last_updated'){
                        value = formatDate(value);
                    }
                    // Return the raw value - we'll handle rendering in didDrawCell
                    return value;
                });
            });
        } else {
            // Handle case when tableHeader is not provided
            if (dataList.length > 0) {
                if (Array.isArray(dataList[0])) {
                    // Data is already in array format
                    headers = Array.from({ length: dataList[0].length }, (_, i) => `Column ${i + 1}`);
                    tableData = dataList;
                } else if (typeof dataList[0] === 'object') {
                    // Data is in object format
                    headers = Object.keys(dataList[0]);
                    tableData = dataList.map(item => Object.values(item));
                }
            }
        }
        // Generate the table
        autoTable(doc, {
            head: [headers],
            body: tableData,
            startY: 25,
            didDrawCell: function(data) {
                // Only process body cells
                if (data.section === 'body') {
                    const value = data.cell.raw;
                    // Check if the value is 1/0 or '1'/'0'
                    if (value === 1 || value === '1') {
                        // Draw green circle
                        doc.setFillColor(120, 177, 89); // Green
                        doc.circle(
                            data.cell.x + data.cell.width / 2,
                            data.cell.y + data.cell.height / 2,
                            // data.cell.x + 2,
                            // data.cell.y + 2,
                            1.59, // radius
                            'F' // Fill
                        );
                        // Clear the text that would be drawn
                        data.cell.text = '';
                    } else if (value === 0 || value === '0') {
                        // Draw red circle
                        doc.setFillColor(221, 46, 68); // Red
                        doc.circle(
                            data.cell.x + data.cell.width / 2,
                            data.cell.y + data.cell.height / 2,
                            // data.cell.x + 2,
                            // data.cell.y + 2,
                            1.59, // radius
                            'F' // Fill
                        );
                        // Clear the text that would be drawn
                        data.cell.text = '';
                    }
                }
            },
            didDrawPage: function(data) {
                // Add page number at the bottom
                const pageCount = doc.internal.getNumberOfPages();
                doc.setFontSize(10);
                doc.text(
                    `Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`,
                    data.settings.margin.left,
                    doc.internal.pageSize.height - 10
                );
            },
            margin: { top: 25, bottom: 20, left: 10, right: 10 },
            styles: {
                overflow: 'linebreak',
                // fontSize: 10,
                // cellPadding: 4,
                // valign: 'middle',
                // halign: 'center',
                // overflow: 'linebreak',
                fontSize: 10,
                cellPadding: 2,
                // lineColor: [0, 0, 0],
                // lineWidth: 0.1,
                // valign: 'middle',
                // halign: 'center',
                color: '#E6F6FA',

                lineColor: [221, 221, 221],
                lineWidth: 0.1,
                fillColor: [245, 248, 250], // Body background color
                textColor: [33, 37, 41], // Text color
            },
            headStyles: {
                // fillColor: [200, 200, 200],
                // textColor: [0, 0, 0],
                // fontSize: 10,
                // fontStyle: 'bold',
                // fillColor: [209, 217, 224], // Header background color
                fillColor: process.env.REACT_APP_PRIMARY_COLOR,
                textColor: process.env.REACT_APP_HEADER_TEXT_COLOR,
                fontSize: 8,
                fontStyle: 'bold',
                // halign: 'center',
                // color: '#E6F6FA',
                color: '#fff',
                border: '#fff',
                lineColor: '#fff'
            },
            bodyStyles: {
                textColor: [0, 0, 0],
                fontSize: 7,
                cellPadding: 2,
                lineColor: '#fff',
                lineWidth: 0.1,
                valign: 'middle',
                halign: 'center',
                color: '#E6F6FA',
                border: 'outset',

                // lineColor: '[221, 221, 221]',
                // lineWidth: 0.1,
            },
            alternateRowStyles: {
                // fillColor: [240, 240, 240],
                // fillColor: [0, 19, 23],
                fillColor: [249, 249, 249],
            },
        });
        // Save the PDF
        const pdfBlob = doc.output('blob');
        FileSaver.saveAs(pdfBlob, `${tag}-${currentDate}${fileExtension}`);
    };
 
    return (
<ButtonComponent
            tag={"Export PDF"}
            onButtonClick={() => onExport()}
            border={'#000 1px solid'}
            background={'#fff'}
            color={'#001317'}
            width={'88px'}
        />
    );
};
 
export default ExportPDFButton;
